import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME } from '@modules/affiliates-approved/submodules/trackers-settings/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_MAIN,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedTrackersSettingsMainModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME,
      path: 'main',
      component: () => import('./pages/TrackersSettingsMainPage/TrackersSettingsMainPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_MAIN, getTranslationKeys);
  }
}
